import {useColorScheme} from "@mui/material";
import React, {useContext, useEffect, useMemo, useState} from "react";
import {toast, ToastContainer, Zoom} from "react-toastify";
import {useUpdateEffect} from "react-use";

const ApplicationToastContainerContext = React.createContext([]);

/**
 * A hook that returns the active toast ids.
 * @return {*[]}
 */
export const useApplicationToastContainer = () => {
    return useContext(ApplicationToastContainerContext);
}


const ApplicationToastContainer = () => {
    const {mode, systemMode} = useColorScheme();
    const [activeToastIds, setToastIds] = useState([]);

    /**@type {'light' | 'dark'}*/
    const toastTheme = useMemo(() => {
        switch (mode) {
            case "dark":
            case "light":
                return mode;
            default:
                switch (systemMode) {
                    case "dark":
                    case "light":
                        return systemMode;
                    default:
                        return 'light';
                }
        }
    }, [mode, systemMode])

    /**
     * As soon as the component mounts:
     * - attaches an event listener on the toasts that would store the ids of the added toasts and remove the ids of the removed toasts.
     */
    useEffect(() => toast.onChange(e => {
        switch (e.status) {
            case "added":
                setToastIds(prevState => [...prevState, e.id]);
                break;
            case "removed":
                setToastIds(prevState => prevState.filter(id => id !== e.id))
                break;
            default:
                break;
        }
    }), [])

    /**
     * With each change in the [toastTheme] memo value:
     * - updates the theme of the shown toasts to be in sync the current [toastTheme].
     */
    useUpdateEffect(() => {
        setToastIds(prevState => {
            for (let toastId of prevState) {
                if (toast.isActive(toastId))
                    toast.update(toastId, {
                        theme: toastTheme,
                    });
            }
            return prevState;
        })
    }, [toastTheme])

    return (
        <>
            <ApplicationToastContainerContext.Provider value={activeToastIds}>
                <ToastContainer
                    position={'top-right'}
                    autoClose={5000}
                    closeOnClick
                    closeButton={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    transition={Zoom}
                    theme={toastTheme}
                    stacked
                />
            </ApplicationToastContainerContext.Provider>
        </>
    );
}


export default ApplicationToastContainer;
